var React = require('react');

function IconAgent (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.72 14.76a7.15 7.15 0 00.24-4.81 9.05 9.05 0 01-6.22-.78A9.07 9.07 0 019.5 6.34a9.21 9.21 0 01-4.73 4.88c-.04.25-.04.52-.04.78a7.27 7.27 0 0010.24 6.63c.57 1.09.83 1.63.81 1.63-1.64.55-2.91.82-3.78.82a9.05 9.05 0 01-8.67-6.35H2v-4.55h1.09a9.09 9.09 0 0117.8 0H22v4.55h-.06L18.38 18l-5.3-.6v-1.67h4.83l.81-.97zm-9.45-2.99a1.14 1.14 0 01.8 1.94c-.21.21-.5.33-.8.33-.63 0-1.14-.5-1.14-1.13 0-.63.51-1.14 1.14-1.14zm5.45 0c.63 0 1.13.51 1.13 1.14 0 .63-.5 1.13-1.13 1.13a1.13 1.13 0 01-.8-1.94c.2-.21.5-.33.8-.33z"}));
}

IconAgent.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconAgent;

IconAgent.default = IconAgent;
